/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseStatisticsQueryRequest
 */
export interface CaseStatisticsQueryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    tenantIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    tenantName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    severity?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    status?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    owner?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CaseStatisticsQueryRequest
     */
    escalated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    search?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    createdFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    createdTo?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    updatedFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatisticsQueryRequest
     */
    updatedTo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    entities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    events?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CaseStatisticsQueryRequest
     */
    matchCase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseStatisticsQueryRequest
     */
    wholeWord?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseStatisticsQueryRequest
     */
    useRegex?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseStatisticsQueryRequest
     */
    resolutionReasonValues?: Array<string>;
}

/**
 * Check if a given object implements the CaseStatisticsQueryRequest interface.
 */
export function instanceOfCaseStatisticsQueryRequest(value: object): value is CaseStatisticsQueryRequest {
    return true;
}

export function CaseStatisticsQueryRequestFromJSON(json: any): CaseStatisticsQueryRequest {
    return CaseStatisticsQueryRequestFromJSONTyped(json, false);
}

export function CaseStatisticsQueryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseStatisticsQueryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantIds': json['tenantIds'] == null ? undefined : json['tenantIds'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'status': json['status'] == null ? undefined : json['status'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'escalated': json['escalated'] == null ? undefined : json['escalated'],
        'search': json['search'] == null ? undefined : json['search'],
        'id': json['id'] == null ? undefined : json['id'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'createdFrom': json['createdFrom'] == null ? undefined : json['createdFrom'],
        'createdTo': json['createdTo'] == null ? undefined : json['createdTo'],
        'updatedFrom': json['updatedFrom'] == null ? undefined : json['updatedFrom'],
        'updatedTo': json['updatedTo'] == null ? undefined : json['updatedTo'],
        'entities': json['entities'] == null ? undefined : json['entities'],
        'events': json['events'] == null ? undefined : json['events'],
        'matchCase': json['matchCase'] == null ? undefined : json['matchCase'],
        'wholeWord': json['wholeWord'] == null ? undefined : json['wholeWord'],
        'useRegex': json['useRegex'] == null ? undefined : json['useRegex'],
        'resolutionReasonValues': json['resolutionReasonValues'] == null ? undefined : json['resolutionReasonValues'],
    };
}

export function CaseStatisticsQueryRequestToJSON(json: any): CaseStatisticsQueryRequest {
    return CaseStatisticsQueryRequestToJSONTyped(json, false);
}

export function CaseStatisticsQueryRequestToJSONTyped(value?: CaseStatisticsQueryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantIds': value['tenantIds'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'severity': value['severity'],
        'status': value['status'],
        'owner': value['owner'],
        'escalated': value['escalated'],
        'search': value['search'],
        'id': value['id'],
        'sourceId': value['sourceId'],
        'createdFrom': value['createdFrom'],
        'createdTo': value['createdTo'],
        'updatedFrom': value['updatedFrom'],
        'updatedTo': value['updatedTo'],
        'entities': value['entities'],
        'events': value['events'],
        'matchCase': value['matchCase'],
        'wholeWord': value['wholeWord'],
        'useRegex': value['useRegex'],
        'resolutionReasonValues': value['resolutionReasonValues'],
    };
}

